import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Composer1pt8hwk95abxi as Composer,
  ComposerForUnquotedLiterals3v0rwxdudtla9 as ComposerForUnquotedLiterals,
  ComposerForUnsignedNumbers2h1dv6l9z3aef as ComposerForUnsignedNumbers,
} from './Composers.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance25nhr3t715wdo as CLASS_getInstance,
  OBJECT_getInstance167untwb9admi as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClassDiscriminatorMode_NONE_getInstance39dg6hx0yqfbs as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  access$checkEncodingConflicts$tPolymorphicKt2migrcemidykb as access$checkEncodingConflicts$tPolymorphicKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './Polymorphic.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { switchMode35g725ikhjpwv as switchMode } from './WriteMode.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import { InvalidFloatingPointEncoded3n0aum4e9o5qi as InvalidFloatingPointEncoded } from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf as get_jsonUnquotedLiteralDescriptor } from '../JsonElement.mjs';
import { Companion_getInstance1339zuieiizg3 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  serializer3ikrxnm8b29d6 as serializer,
  serializer2lw83vwvpnyms as serializer_0,
  serializer36584sjyg5661 as serializer_1,
  serializer1q7c5q67ysppr as serializer_2,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance2ln0tj1crqgxz as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance2utgi65n0nnqj as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance3rx8u2n07bmtm as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.g2s_1.x2p();
  $this.d1s(discriminator);
  $this.g2s_1.a2q(_Char___init__impl__6a9atx(58));
  $this.g2s_1.z2p();
  $this.d1s(serialName);
}
var StreamingJsonEncoderClass;
function StreamingJsonEncoder() {
  if (StreamingJsonEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static z2t(composer, json, mode, modeReuseCache) {
        var $this = this.r1r();
        $this.g2s_1 = composer;
        $this.h2s_1 = json;
        $this.i2s_1 = mode;
        $this.j2s_1 = modeReuseCache;
        $this.k2s_1 = $this.h2s_1.n1r();
        $this.l2s_1 = $this.h2s_1.a2m_1;
        $this.m2s_1 = false;
        $this.n2s_1 = null;
        $this.o2s_1 = null;
        var i = $this.i2s_1.w1_1;
        if (!($this.j2s_1 == null)) {
          if (!($this.j2s_1[i] === null) || !($this.j2s_1[i] === $this)) {
            $this.j2s_1[i] = $this;
          }
        }
        return $this;
      }
      c2o() {
        return this.h2s_1;
      }
      static p2s(output, json, mode, modeReuseCache) {
        return this.z2t(Composer(output, json), json, mode, modeReuseCache);
      }
      n1r() {
        return this.k2s_1;
      }
      w1s(descriptor, index) {
        return this.l2s_1.l2n_1;
      }
      r1s(serializer, value) {
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
          if (this.c2o().a2m_1.t2n_1) {
            serializer.i1m(this, value);
            break $l$block;
          }
          var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
          var tmp;
          if (isPolymorphicSerializer) {
            tmp = !this.c2o().a2m_1.b2o_1.equals(ClassDiscriminatorMode_NONE_getInstance());
          } else {
            var tmp_0;
            switch (this.c2o().a2m_1.b2o_1.w1_1) {
              case 0:
              case 2:
                tmp_0 = false;
                break;
              case 1:
                // Inline function 'kotlin.let' call

                var it = serializer.h1m().d1p();
                tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            tmp = tmp_0;
          }
          var needDiscriminator = tmp;
          var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.h1m(), this.c2o()) : null;
          var tmp_1;
          if (isPolymorphicSerializer) {
            var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (value == null) {
                var message = 'Value for serializer ' + toString_0(serializer.h1m()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                throw IllegalArgumentException().n2(toString_0(message));
              } else {
                break $l$block_0;
              }
            }
            var actual = findPolymorphicSerializer(casted, this, value);
            tmp_1 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
          } else {
            tmp_1 = serializer;
          }
          var actualSerializer = tmp_1;
          if (!(baseClassDiscriminator == null)) {
            access$checkEncodingConflicts$tPolymorphicKt(this.c2o(), serializer, actualSerializer, baseClassDiscriminator);
            checkKind(actualSerializer.h1m().d1p());
            var serialName = actualSerializer.h1m().k1n();
            this.n2s_1 = baseClassDiscriminator;
            this.o2s_1 = serialName;
          }
          actualSerializer.i1m(this, value);
        }
      }
      y1q(descriptor) {
        var newMode = switchMode(this.h2s_1, descriptor);
        if (!(newMode.s2t_1 === _Char___init__impl__6a9atx(0))) {
          this.g2s_1.a2q(newMode.s2t_1);
          this.g2s_1.v2p();
        }
        var discriminator = this.n2s_1;
        if (!(discriminator == null)) {
          var tmp0_elvis_lhs = this.o2s_1;
          encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.k1n() : tmp0_elvis_lhs);
          this.n2s_1 = null;
          this.o2s_1 = null;
        }
        if (this.i2s_1.equals(newMode)) {
          return this;
        }
        var tmp1_safe_receiver = this.j2s_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.w1_1];
        return tmp2_elvis_lhs == null ? StreamingJsonEncoder().z2t(this.g2s_1, this.h2s_1, newMode, this.j2s_1) : tmp2_elvis_lhs;
      }
      z1q(descriptor) {
        if (!(this.i2s_1.t2t_1 === _Char___init__impl__6a9atx(0))) {
          this.g2s_1.w2p();
          this.g2s_1.y2p();
          this.g2s_1.a2q(this.i2s_1.t2t_1);
        }
      }
      s1r(descriptor, index) {
        switch (this.i2s_1.w1_1) {
          case 1:
            if (!this.g2s_1.u2p_1) {
              this.g2s_1.a2q(_Char___init__impl__6a9atx(44));
            }

            this.g2s_1.x2p();
            break;
          case 2:
            if (!this.g2s_1.u2p_1) {
              var tmp = this;
              var tmp_0;
              if ((index % 2 | 0) === 0) {
                this.g2s_1.a2q(_Char___init__impl__6a9atx(44));
                this.g2s_1.x2p();
                tmp_0 = true;
              } else {
                this.g2s_1.a2q(_Char___init__impl__6a9atx(58));
                this.g2s_1.z2p();
                tmp_0 = false;
              }
              tmp.m2s_1 = tmp_0;
            } else {
              this.m2s_1 = true;
              this.g2s_1.x2p();
            }

            break;
          case 3:
            if (index === 0)
              this.m2s_1 = true;
            if (index === 1) {
              this.g2s_1.a2q(_Char___init__impl__6a9atx(44));
              this.g2s_1.z2p();
              this.m2s_1 = false;
            }

            break;
          default:
            if (!this.g2s_1.u2p_1) {
              this.g2s_1.a2q(_Char___init__impl__6a9atx(44));
            }

            this.g2s_1.x2p();
            this.d1s(getJsonElementName(descriptor, this.h2s_1, index));
            this.g2s_1.a2q(_Char___init__impl__6a9atx(58));
            this.g2s_1.z2p();
            break;
        }
        return true;
      }
      s1s(descriptor, index, serializer, value) {
        if (!(value == null) || this.l2s_1.q2n_1) {
          super.s1s(descriptor, index, serializer, value);
        }
      }
      f1s(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_0;
          var tmp_1 = this.g2s_1;
          if (tmp_1 instanceof ComposerForUnsignedNumbers()) {
            tmp_0 = this.g2s_1;
          } else {
            var tmp0 = this.g2s_1.t2p_1;
            var p1 = this.m2s_1;
            tmp_0 = new (ComposerForUnsignedNumbers())(tmp0, p1);
          }
          var tmp$ret$0 = tmp_0;
          tmp = StreamingJsonEncoder().z2t(tmp$ret$0, this.h2s_1, this.i2s_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_2;
          var tmp_3 = this.g2s_1;
          if (tmp_3 instanceof ComposerForUnquotedLiterals()) {
            tmp_2 = this.g2s_1;
          } else {
            var tmp0_0 = this.g2s_1.t2p_1;
            var p1_0 = this.m2s_1;
            tmp_2 = new (ComposerForUnquotedLiterals())(tmp0_0, p1_0);
          }
          var tmp$ret$2 = tmp_2;
          tmp = StreamingJsonEncoder().z2t(tmp$ret$2, this.h2s_1, this.i2s_1, null);
        } else if (!(this.n2s_1 == null)) {
          // Inline function 'kotlin.apply' call
          this.o2s_1 = descriptor.k1n();
          tmp = this;
        } else {
          tmp = super.f1s(descriptor);
        }
        return tmp;
      }
      u1r() {
        this.g2s_1.c2q('null');
      }
      v1r(value) {
        if (this.m2s_1) {
          this.d1s(value.toString());
        } else {
          this.g2s_1.l2q(value);
        }
      }
      w1r(value) {
        if (this.m2s_1) {
          this.d1s(value.toString());
        } else {
          this.g2s_1.g2q(value);
        }
      }
      x1r(value) {
        if (this.m2s_1) {
          this.d1s(value.toString());
        } else {
          this.g2s_1.i2q(value);
        }
      }
      y1r(value) {
        if (this.m2s_1) {
          this.d1s(value.toString());
        } else {
          this.g2s_1.j2q(value);
        }
      }
      z1r(value) {
        if (this.m2s_1) {
          this.d1s(value.toString());
        } else {
          this.g2s_1.k2q(value);
        }
      }
      a1s(value) {
        if (this.m2s_1) {
          this.d1s(value.toString());
        } else {
          this.g2s_1.e2q(value);
        }
        if (!this.l2s_1.v2n_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value, toString_0(this.g2s_1.t2p_1));
        }
      }
      b1s(value) {
        if (this.m2s_1) {
          this.d1s(value.toString());
        } else {
          this.g2s_1.f2q(value);
        }
        if (!this.l2s_1.v2n_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value, toString_0(this.g2s_1.t2p_1));
        }
      }
      c1s(value) {
        this.d1s(toString(value));
      }
      d1s(value) {
        return this.g2s_1.m2q(value);
      }
      e1s(enumDescriptor, index) {
        this.d1s(enumDescriptor.h1p(index));
      }
    }
    initMetadataForClass($, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder()]);
    StreamingJsonEncoderClass = $;
  }
  return StreamingJsonEncoderClass;
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.e1p() && get_unsignedNumberDescriptors().t2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.e1p() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer(Companion_getInstance()).h1m(), serializer_0(Companion_getInstance_0()).h1m(), serializer_1(Companion_getInstance_1()).h1m(), serializer_2(Companion_getInstance_2()).h1m()]);
  }
}
//region block: exports
export {
  StreamingJsonEncoder as StreamingJsonEncoder1wswwd0g47gwe,
  get_isUnsignedNumber as get_isUnsignedNumber3dxwaa3af8ncr,
};
//endregion

//# sourceMappingURL=StreamingJsonEncoder.mjs.map
